angular.module('edxComponents')
  .component('edxNweaDomainDropdown', {
    templateUrl: '/resources/components/assign-focus/create-nwea-assignment/nwea-domain-dropdown.component.html',
    controller: ['edxNweaAssignmentService', NweaDomainDropdownController],
    controllerAs: 'vm',
    bindings: {
      onSelect: '&edxOnSelect',
      disabled: '<edxDisabled',
      studentId: '<edxStudentId',
      domainId: '<edxDomainId',
      levelId: '<edxLevelId'
    }
  });

function NweaDomainDropdownController(nweaAssignmentService) {
  var vm = this;

  vm.$onChanges = $onChanges;
  vm.isDisabled = isDisabled;
  vm.onClick = onClick;

  var DO_NOT_ASSIGN_DOMAIN_OPTION = {
    id: '-1',
    ordinal: -1,
    name: "Don't Assign"
  };

  vm.selected = DO_NOT_ASSIGN_DOMAIN_OPTION;
  vm.loading = true;
  vm.domains = [];

  var lastSentValue;

  function $onChanges(changes) {
    if (changes.levelId || changes.studentId) {
      updateDomains();
      sendSelectionIfChanged(vm.selected);
    }
  }

  function updateDomains() {
    if(vm.studentId && vm.levelId){
      vm.selected = DO_NOT_ASSIGN_DOMAIN_OPTION;
      nweaAssignmentService.loadDomainsForStudent(vm.studentId, vm.levelId).then(function (domains) {
        vm.domains = [DO_NOT_ASSIGN_DOMAIN_OPTION].concat(domains);
      }).catch(function(){
        vm.domains = [];
      }).finally(function(){
        vm.loading = false;
      });

    }
  }

  function isDisabled() {
    return !vm.domains || vm.domains.length <= 0 || vm.disabled;
  }

  function onClick(model) {
    sendSelectionIfChanged(model);
  }

  function sendSelectionIfChanged(model) {
    if (lastSentValue !== model) {
      lastSentValue = model;
      if (model && model.id === DO_NOT_ASSIGN_DOMAIN_OPTION.id) {
        vm.onSelect({domain: undefined});
      } else {
        vm.onSelect({domain: model});
      }
    }
  }
}
